import { Group, Mesh, Raycaster } from 'three';
import Experience from '../../Experience.js';
import Events from '../../Utils/Events.js';
import Item from './Item.js';

export default class PictureItem extends Item {
    constructor(
        id,
        name,
        title,
        format,
        printType,
        description,
        premio,
        meshes,
        originalPosition,
        observationPoint
    ) {
        super(id, originalPosition, observationPoint);
        this.experience = new Experience();
        this.raycaster = new Raycaster();
        this.highlightColor = 0xfeffd9;
        this.highlightIntensity = 2.0;
        this.isHighlighted = false;

        // Artwork data
        this.artData = {};
        this.artData.name = name;
        this.artData.title = title;
        this.artData.format = format;
        this.artData.printType = printType;
        this.artData.description = description;
        this.artData.premio = premio;

        // Setup
        // this.setMesh(color, position, dimensions);
        this.setMeshes(meshes);
        this.setupListeners();
    }

    // setMesh(color, position, dimensions) {
    //     // this.mesh = new Mesh(
    //     //     new BoxGeometry(dimensions.x, dimensions.y, dimensions.z),
    //     //     new MeshStandardMaterial({ color: color })
    //     // );
    //     // this.mesh.position.set(position.x, position.y, position.z);
    //     // this.mesh.material.userData.originalColor = color
    //     // this.mesh.receiveShadow = true;
    //     // this.mesh.castShadow = true;
    //     // this.mesh.userData = this;
    //     // this.scene.add(this.mesh);
    // }

    setMeshes(meshes) {
        this.isInstanceOfGroup = meshes instanceof Group;
        this.meshes = meshes;
        if (this.isInstanceOfGroup) {
            this.meshes.traverse((child) => {
                if (child instanceof Mesh) {
                    child.userData = this;
                }
            });
        } else {
            this.meshes.userData = this;
        }
    }

    setupListeners() {
        this.onItemHover = (event) => {
            event.preventDefault();
            this.raycaster.setFromCamera(
                this.experience.pointer.coordinates,
                this.experience.camera.instance
            );
            const intersects = this.raycaster.intersectObject(this.meshes, true);

            this.isHighlighted = intersects.length > 0;
            if (this.isHighlighted && !this.hasFocus) {
                this.setEmissiveIntensity(this.highlightIntensity);
            } else {
                this.setEmissiveIntensity(1.0);
            }
        };

        this.experience.canvas.addEventListener('mousemove', this.onItemHover, false);
        this.experience.canvas.addEventListener('touchstart', this.onItemHover, false);
        this.experience.canvas.addEventListener('touchmove', this.onItemHover, false);
        this.eventEmitter.on(Events.ITEM_HAS_FOCUS, this, (item) => {
            if (item === this) {
                this.setEmissiveIntensity(1.0);
            }
        });
    }

    setEmissiveIntensity(intensity) {
        if (this.isInstanceOfGroup) {
            this.meshes.traverse((child) => {
                if (
                    child instanceof Mesh &&
                    child.material.emissiveIntensity != intensity
                ) {
                    child.material.emissiveIntensity = intensity;
                }
            });
        } else {
            if (this.meshes.material.emissiveIntensity != intensity) {
                this.meshes.material.emissiveIntensity = intensity;
            }
        }
    }

    destroy() {
        this.meshes.geometry.dispose();
        this.meshes.material.dispose();
        this.scene.remove(this.meshes);

        this.experience.canvas.removeEventListener('mousemove', this.onItemHover, false);
        this.experience.canvas.removeEventListener('touchstart', this.onItemHover, false);
        this.experience.canvas.removeEventListener('touchmove', this.onItemHover, false);
        this.eventEmitter.off(Events.ITEM_HAS_FOCUS, this);
    }
}
